import * as React from 'react';

interface CueProps {
  cue: string;
  highlighted?: boolean;
}

const Cue: React.FC<CueProps> = ({ cue, highlighted }) => (
  <span className={highlighted ? 'cue-text karaoke-highlight' : 'cue-text'}>{cue}</span>
);

export { Cue };
